"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _DeletedObjects_1 = require("./_DeletedObjects");
var _Errors_1 = require("./_Errors");
exports.DeleteObjectsOutput = {
    type: "structure",
    required: [],
    members: {
        Deleted: {
            shape: _DeletedObjects_1._DeletedObjects
        },
        RequestCharged: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "x-amz-request-charged"
        },
        Errors: {
            shape: _Errors_1._Errors,
            locationName: "Error"
        }
    }
};
//# sourceMappingURL=DeleteObjectsOutput.js.map